import React from 'react';
import { TrainingData } from './TrainingWizard';
// Mock data for training types
const mockTrainingTypes = [{
  id: 1,
  name: 'Sliptraining Basis',
  description: 'Basistraining voor voertuigbeheersing op glad wegdek.',
  duration: 180,
  minParticipants: 4,
  maxParticipants: 8,
  color: 'blue'
}, {
  id: 2,
  name: 'Defensief Rijden',
  description: 'Training gericht op anticiperend en veilig rijgedrag in het verkeer.',
  duration: 240,
  minParticipants: 4,
  maxParticipants: 12,
  color: 'green'
}, {
  id: 3,
  name: 'Sliptraining Gevorderd',
  description: 'Geavanceerde training voor voertuigbeheersing in extreme situaties.',
  duration: 210,
  minParticipants: 4,
  maxParticipants: 6,
  color: 'purple'
}, {
  id: 4,
  name: 'Code 95 Training',
  description: 'Verplichte nascholing voor beroepschauffeurs.',
  duration: 300,
  minParticipants: 8,
  maxParticipants: 16,
  color: 'yellow'
}, {
  id: 5,
  name: 'Calamiteitentraining',
  description: 'Specifieke training voor hulpdiensten en calamiteitenrespons.',
  duration: 180,
  minParticipants: 6,
  maxParticipants: 10,
  color: 'red'
}];
interface TrainingTypeStepProps {
  trainingData: TrainingData;
  updateTrainingData: (data: Partial<TrainingData>) => void;
}
export function TrainingTypeStep({
  trainingData,
  updateTrainingData
}: TrainingTypeStepProps) {
  const handleTrainingTypeSelect = (typeId: number) => {
    const selectedType = mockTrainingTypes.find(type => type.id === typeId);
    if (selectedType) {
      updateTrainingData({
        trainingTypeId: typeId,
        trainingTypeName: selectedType.name
      });
    }
  };
  // Get color class for training type
  const getTrainingTypeColor = (color: string) => {
    const colorMap = {
      blue: 'bg-blue-100 border-blue-300 text-blue-800 hover:bg-blue-200',
      green: 'bg-green-100 border-green-300 text-green-800 hover:bg-green-200',
      purple: 'bg-purple-100 border-purple-300 text-purple-800 hover:bg-purple-200',
      yellow: 'bg-yellow-100 border-yellow-300 text-yellow-800 hover:bg-yellow-200',
      red: 'bg-red-100 border-red-300 text-red-800 hover:bg-red-200'
    };
    return colorMap[color] || 'bg-gray-100 border-gray-300 text-gray-800 hover:bg-gray-200';
  };
  // Format duration in hours and minutes
  const formatDuration = (minutes: number) => {
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return `${hours}${mins > 0 ? `:${mins.toString().padStart(2, '0')}` : ''} uur`;
  };
  return <div data-id="element-3430">
      <h2 className="text-lg font-medium text-gray-900 mb-4" data-id="element-3431">
        Selecteer Type Training
      </h2>
      <div className="space-y-4" data-id="element-3432">
        {mockTrainingTypes.map(type => <div key={type.id} className={`p-4 border rounded-lg cursor-pointer transition ${trainingData.trainingTypeId === type.id ? `${getTrainingTypeColor(type.color)} border-2` : 'border-gray-200 hover:border-gray-300 hover:bg-gray-50'}`} onClick={() => handleTrainingTypeSelect(type.id)} data-id="element-3433">
            <div className="flex justify-between items-start" data-id="element-3434">
              <div data-id="element-3435">
                <h3 className="font-medium text-gray-900" data-id="element-3436">{type.name}</h3>
                <p className="text-sm text-gray-600 mt-1" data-id="element-3437">{type.description}</p>
              </div>
              <div className="text-right" data-id="element-3438">
                <p className="text-sm font-medium text-gray-900" data-id="element-3439">
                  {formatDuration(type.duration)}
                </p>
                <p className="text-xs text-gray-500 mt-1" data-id="element-3440">
                  {type.minParticipants}-{type.maxParticipants} deelnemers
                </p>
              </div>
            </div>
          </div>)}
      </div>
    </div>;
}